export const getCaptionTrackingProps = ({
  subtitleLanguage
}) => Object.assign({
  captionsEnabled: !!subtitleLanguage
}, subtitleLanguage && {
  selectedLanguage: subtitleLanguage
});